module.exports = __webpack_public_path__ + "Atlas2_logo_light.f985f7d4049f6b7f4b7b71738c1dc17a.png";